import { MouseEventHandler } from 'react';

import useContactFormTracking from './useContactFormTracking';

export function useContactFormLinkClick(contactFormSlug?: string) {
  const { captureContactFormLinkClicked } = useContactFormTracking();

  const handleLinkClick: MouseEventHandler<HTMLElement> = (event) => {
    const target = event.target as HTMLAnchorElement;

    if (target.tagName === 'A') {
      captureContactFormLinkClicked(target.href, target.textContent ?? '', contactFormSlug ?? '');
    }
  };

  return { handleLinkClick };
}
